import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ChartsModule } from 'ng2-charts';
import { MomentModule } from 'angular2-moment';
import { MatTooltipModule } from '@angular/material/tooltip';
// call translate lazy
import { TranslateLazyModule } from '../translate/translate-lazy.module';

import { NavbarComponent } from './navbar/navbar.component';
import { SideMenuComponent } from './sidemenu/sidemenu.component';
import { FooterComponent } from './footer/footer.component';
import { PointsComponent } from './points/points.component';
import { GainComponent } from './gain/gain.component';
import { ContributorsComponent } from './contributors/contributors.component';
import { HighlightsComponent } from './highlights/highlights.component';
import { TrainingAndProductsComponent } from './training-and-products/training-and-products.component';
import { MenuForumComponent } from './menu-forum/menu-forum.component';
import { ChallengesComponent } from './challenges/challenges.component';
import { ChallengesDetailsCongrulationsDialog } from './challenges/challenges-details-congrulations/challenges-details-congrulations.component';
import { ChallengesDetailsDialog } from './challenges/challenges-details-modal/challenges-details-modal.component';
import { ChallengesChartsComponent } from './challenges-charts/challenges-charts.component';
import { PlaylistComponent } from './playlist/playlist.component';
import { ListArticlesComponent } from './list-articles/list-articles.component';
import { ListTechnicalComponent } from './list-technical/list-technical.component';
import { RankingComponent } from './ranking/ranking.component';
import { ProgressComponent } from './progress/progress.component';
import { HighlightSearchPipe } from './pipes/index';

//import { UploadModule } from './upload/upload.module';
import { UploadModule } from 'app/modules/shared/upload/upload.module';
import { SharedLoadingComponent } from './loading/loading.component';

// Tutor Panel
import { SideMenuTutorComponent } from './sidemenu-tutor/sidemenu-tutor.component';
import { PipesModule } from 'app/@core/pipes/pipe.module';
import { UserEditDialogComponent } from './user-edit-dialog/user-edit-dialog.component';
import { MatInputModule, MatSelectModule, MatProgressBarModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { SpinnerModule } from 'app/modules/shared/spinner/spinner.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    RouterModule,
    ChartsModule,
    MomentModule,
    UploadModule,
    TranslateLazyModule,
    MatTooltipModule,
    PipesModule,
    SpinnerModule,
    MatProgressBarModule
  ],
  declarations: [
    NavbarComponent,
    SideMenuComponent,
    FooterComponent,
    PointsComponent,
    GainComponent,
    ContributorsComponent,
    HighlightsComponent,
    TrainingAndProductsComponent,
    MenuForumComponent,
    PlaylistComponent,
    ListArticlesComponent,
    ListTechnicalComponent,
    ChallengesComponent,
    ChallengesDetailsCongrulationsDialog,
    ChallengesDetailsDialog,
    ChallengesChartsComponent,
    RankingComponent,
    ProgressComponent,
    HighlightSearchPipe,
    SideMenuTutorComponent,
    SharedLoadingComponent,
    UserEditDialogComponent
  ],
  exports: [
    NavbarComponent,
    SideMenuComponent,
    FooterComponent,
    PointsComponent,
    GainComponent,
    ContributorsComponent,
    HighlightsComponent,
    TrainingAndProductsComponent,
    MenuForumComponent,
    PlaylistComponent,
    ListArticlesComponent,
    ListTechnicalComponent,
    ChallengesComponent,
    ChallengesDetailsCongrulationsDialog,
    ChallengesDetailsDialog,
    ChallengesChartsComponent,
    RankingComponent,
    ProgressComponent,
    HighlightSearchPipe,
    UploadModule,
    TranslateLazyModule,
    SideMenuTutorComponent,
    SharedLoadingComponent,
    UserEditDialogComponent
  ],
  entryComponents: [
    ChallengesDetailsCongrulationsDialog,
    ChallengesDetailsDialog,
    UserEditDialogComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts